import fp from 'lodash/fp'

const createFormatFunction = (prop) =>
  fp.map((option) => {
    const { [prop]: id, description } = option

    return {
      id,
      name: description || fp.capitalize(id),
    }
  })

export const getOptionLabel = fp.prop('name')

export const getOptionValue = fp.prop('id')

export const formatCategories = createFormatFunction('category')

export const toSearchableCategory = (sports) => sports.id
